import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';
import UnauthorizedPage from '../client/pages/UnauthorizedPage';

const PrivateRoute = ({ children, roles }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    
    // 1. Loading State: Show spinner, don't redirect yet. Critical for fixing the loop.
    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // 2. Not Logged In: Redirect to Login
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. Wrong Role: Show Access Denied (No redirect)
    if (roles && !roles.includes(user.role)) {
        return <UnauthorizedPage />;
    }

    // 4. Authorized: Render the page
    return children;
};

export default PrivateRoute;